import { ROUTES } from "routes";

export const REGISTER_RETURN_PATH_STORAGE_KEY = "twoghether:register:returnPath";

/**
 * Persists the page the user was on before entering the registration funnel.
 */
export function saveRegisterReturnPath(pathname: string, search: string): void {
    if (typeof window === "undefined") return;
    const path = `${pathname}${search}`;
    if (!isSafeInternalPath(path)) return;
    try {
        window.sessionStorage.setItem(REGISTER_RETURN_PATH_STORAGE_KEY, path);
    } catch (err) {
        console.warn("[registerReturnPath] Failed to save return path to sessionStorage", err);
    }
}

/**
 * Returns a safe in-app path for navigation, or HOME as fallback.
 */
export function getRegisterReturnPath(fallback = ROUTES.HOME): string {
    if (typeof window === "undefined") return fallback;
    try {
        const stored = window.sessionStorage.getItem(REGISTER_RETURN_PATH_STORAGE_KEY);
        if (stored && isSafeInternalPath(stored)) return stored;
    } catch (err) {
        console.warn("[registerReturnPath] Failed to read return path from sessionStorage", err);
    }
    return fallback;
}

export function clearRegisterReturnPath(): void {
    if (typeof window === "undefined") return;
    try {
        window.sessionStorage.removeItem(REGISTER_RETURN_PATH_STORAGE_KEY);
    } catch (err) {
        console.warn("[registerReturnPath] Failed to clear return path from sessionStorage", err);
    }
}

/**
 * Accepts same-origin relative paths only (no protocol-relative or external URLs).
 */
export function isSafeInternalPath(path: string): boolean {
    if (!path.startsWith("/") || path.startsWith("//")) return false;
    if (path.includes("://")) return false;
    return true;
}
